import { RequestCoords } from "../services/DangerZones/DangerZones.type";

export type Zone = {
  name: string;
  polygon: google.maps.LatLngLiteral[];
};

export type ZonePolygon = {
  name: string;
  polygon: google.maps.Polygon;
};

export type IsAddressDangerousReturnValue = {
  isDangerous: boolean;
  dangerousZone?: string;
  error: boolean;
  message?: string;
  location?: google.maps.LatLngLiteral;
};

export const createGooglePolygons = ({ name, polygon }: Zone): ZonePolygon => {
  const newPolygon = new google.maps.Polygon({ paths: polygon });

  return { name, polygon: newPolygon };
};

const getLatLngFromAddress = async (
  address: string,
): Promise<google.maps.LatLngLiteral | null> => {
  let geocoder = new google.maps.Geocoder();

  let coords: google.maps.LatLngLiteral | null = null;

  // funcion para geocodigicar la direccion
  try {
    await geocoder.geocode({ address }, (results, status) => {
      if (status === "OK" && results) {
        coords = {
          lat: results[0].geometry.location.lat(),
          lng: results[0].geometry.location.lng(),
        };
      } else {
        return null;
      }
    });

    return coords;
  } catch {
    return null;
  }
};

const isLocationDangerous = (
  location: google.maps.LatLngLiteral,
  zones: ZonePolygon[],
): ZonePolygon | undefined => {
  const poly = google.maps.geometry.poly;

  const isLocationInsidePolygon = ({ polygon }: ZonePolygon) => {
    return location && poly.containsLocation(location, polygon);
  };

  return zones?.find(isLocationInsidePolygon);
};

export const isAddressDangerous = async (
  value: string,
  zones: ZonePolygon[],
): Promise<IsAddressDangerousReturnValue> => {
  if (process.env.REACT_APP_VALIDATE_ADDRESS_DANGEROUS !== "true") {
    return { error: false, isDangerous: false, location: { lat: 0, lng: 0 } };
  }

  const address = `${value}, Argentina`;
  const location = await getLatLngFromAddress(address);

  if (!location)
    return {
      error: true,
      message: "No hemos podido localizar la ubicación. Intente nuevamente.",
      isDangerous: false,
    };

  const dangerousZone = isLocationDangerous(location, zones);

  if (dangerousZone)
    return {
      error: false,
      isDangerous: true,
      dangerousZone: dangerousZone.name,
      location,
    };

  return { error: false, isDangerous: false, location };
};

// parser Functions
export const parsePolygonToRequestCoords = (
  polygon: Array<google.maps.LatLngLiteral>,
): Array<RequestCoords> =>
  polygon.map(({ lat, lng }) => ({
    latitude: lat,
    longitude: lng,
  }));

export const parseRequestCoordsToPolygon = (
  polygon: Array<RequestCoords>,
): Array<google.maps.LatLngLiteral> =>
  polygon.map(({ latitude, longitude }) => ({
    lat: latitude,
    lng: longitude,
  }));
